import { defineComponent } from 'vue'
import type { PropType, ExtractPropTypes } from 'vue'


export const pagetableColumnStringProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
  tail: [Boolean, String],
})

export type PagetableColumnStringProps = Partial<ExtractPropTypes<ReturnType<typeof pagetableColumnStringProps>>>

export default defineComponent({
  name: 'OPagetableColumnString',
  inheritAttrs: false,
  props: pagetableColumnStringProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
